import {Stack, styled} from '@mui/material';
import Icon from 'presentation/icons';

const StyledContainer = styled(Stack)`
	flex-direction: row;
	gap: 12px;
`;

const StyledIcon = styled(Icon)`
	color: ${({theme}) => theme.colors.light.primary.main};
`;

export {StyledContainer, StyledIcon};
